import { css } from 'styled-components';
import { map } from '../../breakpoint';
const validTextAlignValues = ['left', 'center', 'right', 'start', 'end'];
export const textAlign = () => css`
  ${_ref => {
  let {
    textAlign
  } = _ref;
  return map(textAlign, val => val && css`
          text-align: ${val === 'left' || val === 'start' ? 'start' : val === 'right' || val === 'end' ? 'end' : val};
        `);
}};
`;